/** "View Reports" (Roadmap 1862, database update Mg-223). */
export const VIEW_REPORTS_PERMISSION = "6a6626d5-716e-4dda-8169-e998165b5892";

/**
 * Who may open the Reports section (menu item and /reports pages):
 * - Admins always;
 * - others need "View Reports" (Settings > Team);
 * - until the database update (Mg-223) adds the "View Reports" row, nobody can
 *   be given it, so everyone keeps Reports exactly as before.
 * `firmPermissionIds` = the ids of api/permissions/get-list; undefined while it
 * loads (answer: undefined = not known yet). A failed list = not set up = as
 * before (Reports open), because the reports only show data the person may see
 * anyway (firm/own work and billing are checked separately).
 */
export const canOpenReports = (
  isAdmin: boolean,
  userPermissionIds: string[] | null | undefined,
  firmPermissionIds: string[] | undefined,
  listFailed = false,
): boolean | undefined => {
  if (isAdmin) return true;
  if (listFailed) return true;
  if (!firmPermissionIds) return undefined;
  if (!firmPermissionIds.includes(VIEW_REPORTS_PERMISSION)) return true;
  return (userPermissionIds ?? []).includes(VIEW_REPORTS_PERMISSION);
};
